import { FC, PropsWithChildren } from "react";
import { Box, BoxProps, Flex, Image } from "@chakra-ui/react";
import { Text } from "uikit";
import { GreyBox, Heading, SectionContainer, ParallaxImage, TextContent, useIsMobile } from "./shared";

const imageWidth = { base: "auto", md: "390px", lg: "447px", xl: "507px", "2xl": "578px" };

const HeroText = () => (
  <Box px={12} pt={{ base: 12, md: 16 }} pb={{ base: 0, md: 16 }} maxWidth={{ base: "auto", md: "calc(50% + 64px)" }}>
    <Heading mb={8} whiteSpace="nowrap">
      LooksRewarding<Text as="sup">TM</Text>
    </Heading>
    <TextContent mb={8}>
      Earning a share of the protocol fees? Steadily accumulating $LOOKS by flipping the hottest JPEGs? Here, you can
      keep an eye on your rewards — and find out when they&apos;re ready to collect.
    </TextContent>
  </Box>
);

const Phone: FC<PropsWithChildren<BoxProps>> = (props) => (
  <Box position="relative" {...props}>
    <Image src="/images/app-landing-page/rewards-phone.png" alt="rewards-phone" />
    <Box position="absolute" top={0} right={0} height="100%" width="100%">
      <ParallaxImage
        src="/images/app-landing-page/rewards-pane-1.png"
        alt="rewards-pane-1"
        parallaxProps={{ translateX: ["50px", "0px"] }}
      />
      <ParallaxImage
        src="/images/app-landing-page/rewards-pane-2.png"
        alt="rewards-pane-2"
        parallaxProps={{ translateX: ["-50px", "0px"] }}
      />
    </Box>
  </Box>
);

const MobileRewards = () => (
  <SectionContainer baseMaxWidth="390px">
    <GreyBox>
      <HeroText />
      <Phone />
    </GreyBox>
  </SectionContainer>
);

export const Rewards = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileRewards />;
  }

  return (
    <SectionContainer>
      <Flex position="relative" justifyContent="end">
        <GreyBox position="absolute" left={0} top="50%" transform="translateY(-50%)" width="100%">
          <HeroText />
        </GreyBox>
        <Phone width={imageWidth} />
      </Flex>
    </SectionContainer>
  );
};
